import script from "./DetailInvoicePrepaymentFinance.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailInvoicePrepaymentFinance.vue?vue&type=script&setup=true&lang=js"

import "./DetailInvoicePrepaymentFinance.vue?vue&type=style&index=0&id=03f9813c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f9813c"]])

export default __exports__